module.exports = __webpack_public_path__ + "static/media/translate.32969c4c.svg";